import { productFamilyIdFormat } from "@redotech/redo-model/ids";
import { ChannelSchema } from "@redotech/redo-model/marketplace/channels";
import * as z from "zod/v4";

export const deleteProductFamilies = {
  name: "deleteProductFamilies" as const,
  input: z.object({
    productFamilyIds: z.array(productFamilyIdFormat.schema).min(1),
  }),

  output: z.object({
    results: z.array(
      z.object({
        productFamilyId: productFamilyIdFormat.schema,
        success: z.boolean(),
        channelsDeleted: z.array(ChannelSchema),
        error: z.string().optional(),
      }),
    ),
  }),
};
